/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Uno_Memory_LearnedInputs */



/**
* | output |
* | --- |
* | "Noted {time}" |
*
* @param {Uno_Memory_LearnedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_memory_learned = /** @type {((inputs: Uno_Memory_LearnedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Memory_LearnedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Notiert ${i?.time}`)
	return /** @type {LocalizedString} */ (`Noted ${i?.time}`)
});